<template>
    <div class='height'>
        <div class="topBanner">
            <myBanner :imgSrc="imgSrc"/>
            <div v-if="isShowTab" class="showPc">
                <div class="swiper-container swiper2" ref="swiper2" >
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item,index) in themeTypeList" :key="index" :class="{active:index==currentIndex}" @click="itemClick(index,item.id,item.link)">
                            {{item.typeName}}
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="shadow" v-show="isShowTab"></div> -->
        </div>
        <div class="aa showMobile">
             <div ref="tabTitle" class="tabTitle showMobile" v-show="isShowTab">
                <div class="tabItem" v-for="(item,index) in themeTypeList" :key="index" :class="{active:index==currentIndex}" @click="itemClick(index,item.id,item.link)">
                        {{item.typeName}}
                </div>
            </div>
            <img v-show="showAnimate" src="~assets/img/animateTip.png" alt="" class="animateTip">
        </div>
       
        <div class="classifyCont">
            <div class="classifyLeft">
                <div class="topImg">
                    <img src="~assets/img/aside.png" alt="">
                </div>
                <div class="cl_item" 
                    v-for="(item2,index2) in classify" 
                    :key="index2" 
                    :class="{clActive:index2 == curIndexClassify}"
                    @click="classifyClick(index2,item2)">
                    <span>{{item2}}</span>
                </div>
            </div>
            <div class="classifyRight">
                <MyTitle :text="newTitle" v-show="isShowTitle" />
                <div class="newContent mobileWidthMain" v-html="newContent" v-show="newContent"></div>
                <!-- 新增链接 -->
                <div class="link" v-show="newsLink.length">
                    <div class="linkItem" v-for="(item4,index4) in newsLink" :key="index4">
                        <span @click="goLink(item4)">{{item4.linkName}}</span>
                    </div>
                </div>
                <!-- 通用订单 -->
                <div class="generalOrder" v-show="price">
                    <MyButton :butTxt="'¥' + price + ' 支付' " class="advise" @btnClick="btnClick"  />
                </div>
                <!-- 国家 -->
                <div class="countryContent" v-show="isShowCountry">
                    <MyTitle :text="countryText" />
                    <MyCountry :countryInfo="countryList"/>
                </div>
            </div>
        </div>
        <div class="fotBtn">
        </div>
        <!-- 移动端显示 -->
        <div class="m_control">
            <div class="m_titleMenue" v-show="mShowControlMeue">
                <div class="menueItem" 
                    v-for="(item3,index3) in classify" 
                    :key="index3"
                    @click="classifyClick(index3,item3)">
                    <img src="~assets/img/book.png" alt="">
                    <span>{{item3}}</span>
                </div>
                <div class="noData" v-show="noData">暂无数据</div>
            </div>
            <!-- 详情显示 -->
            <div class="m_detail" v-show="!mShowControlMeue">
                <!-- 面包屑 -->
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item><span @click="mShowControlMeue = true">{{title}}</span></el-breadcrumb-item>
                    <el-breadcrumb-item>
                        <!-- {{title2}} 动态的标题 -->
                        详情
                    </el-breadcrumb-item>
                </el-breadcrumb>
                <div class="dashed"></div>
                <!-- 内容 -->
                <MyTitle :text="newTitle" v-show="isShowTitle" />
                <div class="newContent mobileWidthMain" v-html="newContent" v-show="newContent"></div>
                 <!-- 新增链接 -->
                <div class="link" v-show="newsLink.length">
                    <div class="linkItem" v-for="(item4,index4) in newsLink" :key="index4">
                        <span @click="goLink(item4)">{{item4.linkName}}</span>
                    </div>
                </div>
                <!-- 通用订单 -->
                <div class="generalOrder" v-show="price">
                    <MyButton :butTxt="'¥' + price + ' 支付' " class="advise" @btnClick="btnClick"  />
                </div>
                <div class="countryContent" v-show="isShowCountry">
                    <MyTitle :text="countryText" />
                    <MyCountry :countryInfo="countryList"/>
                </div>
                <div class="m_fotBtn">
                    <!-- <MyButton butTxt="线上报名"  v-show="isShowBtn" /> -->
                </div>
            </div>
        </div>

        <!-- 填写信息 -->
        <el-dialog
        :visible.sync="fileVisible"
        :width="dialogWidth2"
        :show-close="false"
        title="填写信息"
        center>
            <div>
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="55px">
                    <el-form-item label="姓名" prop="name" v-if="ruleFormStatus.nameStatus">
                        <el-input v-model="ruleForm.name" placeholder="请输入姓名，与身份证一致"></el-input>
                    </el-form-item>
                    <el-form-item label="手机" prop="mobile" v-if="ruleFormStatus.mobileStatus">
                        <el-input v-model="ruleForm.mobile" placeholder="请输入手机号"></el-input>
                    </el-form-item>
                    <el-form-item label="地址" prop="address" v-if="ruleFormStatus.addressStatus">
                        <el-input v-model="ruleForm.address" placeholder="请输入地址"></el-input>
                    </el-form-item>
                    <el-form-item label="备注" prop="desc" v-if="ruleFormStatus.descStatus">
                        <el-input v-model="ruleForm.desc" placeholder="请输入备注"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="medium" type="primary" @click="submitForm('ruleForm')">确 定</el-button>
                <el-button size="medium" @click="fileVisible = false">取 消</el-button>
            </span>
        </el-dialog>
        <!--  是否登录弹窗-->
        <el-dialog
        title="提示"
        :visible.sync="loginVisible"
        :width="dialogWidth"
        center>
            <div class="loginTxt">登录后可进行支付，是否确定登录？</div>
            <span slot="footer" class="dialog-footer">
                <el-button size="medium" type="primary" @click="goLogin()">确 定</el-button>
                <el-button size="medium" @click="loginVisible = false">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 付款二维码 -->
        <el-dialog
        :visible.sync="codeVisible"
        width="310px"
        center
        :before-close="handleClose">
            <div class="textTip">
                <div> <span>订单名称</span> ：{{newTitle}}</div>
                <p class="money"><span>金额</span>：{{'¥' + price}}</p>
            </div>
            <div id="qrcode" ref="qrcode" ></div>
            <div class="codeTip">
                请使用微信扫一扫<br/>扫描二维码支付
            </div>
        </el-dialog>
        <!-- 订单跳转提醒 -->
        <el-dialog
        title="提示"
        :visible.sync="orderVisible"
        :width="dialogWidth"
        center>
            <div class="loginTxt">{{orderText}}</div>
            <span slot="footer" class="dialog-footer">
                <el-button size="medium" type="primary" @click="goOrderList()">确 定</el-button>
                <el-button size="medium" @click="orderVisible = false">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {getDataMixin,payOrderPc} from "common/mixin.js"
    import { getThemeVo, getListByType,getThemeList, commonOrder } from "network/home.js"
    import getPayOrder from "common/mobilePay"
    import Swiper from "assets/swiper/swiper.js"
    import {isCellPhone} from "common/libs.js"
    export default {
        mixins:[getDataMixin,payOrderPc],
        data(){
            var checkphone = (rule, value, callback) => {
                if (value == "") {
                    callback(new Error("请输入手机号"));
                } else if (!isCellPhone(value)) {
                    callback(new Error("请输入正确的手机号!"));
                } else {
                    callback();
                }
            };
            return {
                themeId:"",
                imgSrc:[],
                themeTypeList:[],
                isShowTab:false,
                newTitle:"",
                newContent:"",
                isShowTitle:false,
                countryText:"留学国家",
                isShowCountry:false,
                countryList:[],
                isShowBtn:false,
                themeList:"",
                currentIndex:0,
                classify:[],
                curIndexClassify:0,
                classifyData:"",
                mShowControlMeue:true,
                title:"",
                title2:"",
                noData:false,
                newsLink:"",
                showAnimate:false, //左右动画
                loginVisible:false,
                dialogWidth:"20%",
                dialogWidth2:"450px",
                fileVisible:false,
                newsId:'',
                ruleForm: {
                    name:'',
                    mobile:'',
                    address:'',
                    desc:''
                },
                ruleFormStatus:{
                    nameStatus:false,
                    mobileStatus:false,
                    addressStatus:false,
                    descStatus:false
                },
                rules: {
                    name: [
                        { required: true, message: '请输入姓名', trigger: 'blur' }
                    ],
                    mobile: [
                        { required: true, validator: checkphone, trigger: 'blur' }
                    ],
                    address: [
                        { required: true, message: '请输入地址', trigger: 'blur' }
                    ],
                },
                price:'',
                tradeType:'NATIVE',
                orderVisible:false,
                orderText:'订单已生成，是否查看订单详情？'
            }
        },
        created(){
            if(this.$IsMobile()){
                this.dialogWidth = '80%'
                this.dialogWidth2 = "80%"
                this.tradeType = "JSAPI"
            }
        },
        mounted(){
            if(this.getCurrentIndex){
                this.currentIndex = this.getCurrentIndex
            }
        },
        activated(){
            if(this.getState){
                this.mShowControlMeue = this.getState
            }
        },
        methods: {
            goLink(item){
                let data = item.link.split('?')[1]
                this.$router.push('/linkDetail?' + data)
            },
            itemClick(index,id,link){
                this.currentIndex = index
                this.curIndexClassify = 0
                this.mShowControlMeue = true
                this.getListByTypeData(id)
                if(link){
                    window.open(link)
                }
            },
            classifyClick(index,item){
                this.curIndexClassify = index
                this.showData(this.classifyData,index)
                if(this.$IsMobile()){
                    this.mShowControlMeue = false
                    this.title2 = item
                }
            },
            showData(data,index){
                this.newTitle = ""
                this.newContent = ""
                this.isShowTitle = false
                this.isShowCountry = false;
                this.countryList = [],
                this.newsLink = ""
                this.price = ""

                this.newTitle = data[index].title
                this.newContent = data[index].content
                this.price = data[index].price
                this.isShowTitle = true,
                this.newsId = data[index].id
                // 弹窗显示条目
                this.ruleFormStatus.nameStatus = data[index].nameStatus
                this.ruleFormStatus.mobileStatus = data[index].mobileStatus
                this.ruleFormStatus.addressStatus = data[index].addressStatus
                this.ruleFormStatus.descStatus = data[index].remarksStatus

                // 获取国家
                let countryData = data[index].countryList
                if(countryData.length){     
                    this.isShowCountry = true;
                    if(!countryData[0].remark){
                        for(let i in countryData){
                            countryData[i].picture = process.env.VUE_APP_WEB_URL + countryData[i].picture
                            countryData[i].remark = true
                        }
                    }
                   
                    this.countryList = countryData
                }
                this.newsLink = data[index].newsLinks
            },
            // 拿到主题id
            getThemeId(index,data){
                if(index){
                    this.themeId = data[index -1].id
                    this.title = data[index - 1].title
                }
                this.getThemeVoData(this.themeId)
                this.currentIndex = 0
                // 判断是否是合作院校，修改标题
                this.countryText = "留学国家"
                this.isShowBtn = false
                if(data[index -1].title == "合作院校"){
                    this.countryText = "合作国家"
                    this.isShowBtn = false
                }else{
                    this.isShowBtn = true
                }
            },
            // 主题下的数据
            getThemeVoData(id){
                this.themeTypeList = []
                getThemeVo(id).then(res=>{
                    localStorage.setItem('levels',JSON.stringify(res.data.levels))
                    let bannerData = res.data.themeBanners
                    if(bannerData.length && bannerData.length == 2){
                        for(let i in bannerData){
                            bannerData.push(bannerData[i])
                        }
                        this.imgSrc = bannerData
                    }else if(bannerData.length){
                        this.imgSrc = bannerData
                    }
                    let newsTypeList = res.data.newsTypeList
                    if(newsTypeList.length){
                        this.themeTypeList = newsTypeList
                        // this.getListByTypeData(this.themeTypeList[0].id)
                        // 当没有相关参数时默认进来获取侧边栏
                        if(!this.getThirdIndex){
                            this.getListByTypeData(this.themeTypeList[0].id)
                        }
                        if(!this.$IsMobile()){
                            this.$nextTick(()=>{
                                new Swiper(this.$refs['swiper2'], {
                                    slidesPerView: 'auto',
                                    spaceBetween: 0,
                                    freeMode: true,
                                    observer:true, //修改自己或者子元素时。自动初始化swiper
                                });

                                if(this.getCurrentIndex){
                                    this.currentIndex = this.getCurrentIndex
                                    this.getListByTypeData(newsTypeList[this.currentIndex].id,true)
                                }
                            })
                        }else{
                            if(this.getCurrentIndex){
                                this.currentIndex = this.getCurrentIndex
                                this.getListByTypeData(newsTypeList[this.currentIndex].id,true)
                                this.mShowControlMeue = false
                            }
                        }
                        
                    }else{
                        this.newTitle = ""
                        this.newContent = ""
                        this.price = ""
                        this.isShowTitle = false
                        this.isShowCountry = false;
                        this.countryList = []
                        this.classify = []
                        this.classifyData = ""
                        this.newsLink = ""
                    }
                    if(newsTypeList.length > 1){
                        this.isShowTab = true
                    }else{
                        this.isShowTab = false
                    }
                    if(newsTypeList.length > 3){
                        this.showAnimate = true
                        let animateTip = document.getElementsByClassName
                        ('animateTip')
                        animateTip[0].style.display = 'block'
                        setTimeout(()=>{
                            animateTip[0].style.display = 'none'
                        },3000)
                    }else{
                        this.showAnimate = false
                    } 
                })
            },
            // 分类下的详情
            getListByTypeData(id,flag){
                this.newTitle = ""
                this.newContent = ""
                this.price = ""
                this.isShowTitle = false
                this.isShowCountry = false;
                this.countryList = []
                this.newsLink = ""
                this.classify = []
                this.classifyData = ""
                this.noData = false
                getListByType(id).then(res=>{
                    if(res.data.length){
                        this.classifyData = res.data
                        // this.showData(res.data,0)
                        for(let i in res.data){
                            this.classify.push(res.data[i].title)
                        }
                        if(this.getThirdIndex && flag){
                            this.curIndexClassify = this.getThirdIndex
                            this.showData(res.data,this.getThirdIndex)
                        }else{
                            this.showData(res.data,0)
                        }
                    }else{
                        this.noData = true
                    }
                    
                })
            },
            getThemeListData(page,pageSize,index) {
                getThemeList({
                    page,
                    pageSize
                }).then(res => {
                    this.themeList = res.data.records;
                    this.getThemeId(index,this.themeList)
                });
            },

            // 通用订单
            btnClick(){
                //未登录登录，登录过后填写信息
                this.loginVisible = !this.isLogin
                this.fileVisible = this.isLogin
            },
            goLogin(){
                let lastLink = window.location.href;
                // 保存当前是哪个页面
                sessionStorage.setItem('lastLink',lastLink + "?currentIndex=" + this.currentIndex + '&thirdIndex=' + this.curIndexClassify)
                this.loginVisible = false
                this.$router.push('/login')
            },
            // 提交信息
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        commonOrder({
                            newsId:this.newsId,
                            customerName:this.ruleForm.name,
                            mobile:this.ruleForm.mobile,
                            address:this.ruleForm.address,
                            remarks:this.ruleForm.desc
                        }).then(res=>{
                            if(res.code == 1){
                                this.fileVisible = false
                                let orderNumber = res.data
                                if(this.$IsMobile()){
                                    getPayOrder({
                                        orderNumber:orderNumber,
                                        tradeType:this.tradeType
                                    },(flag)=>{
                                        if(flag){
                                            this.orderText = "订单支付成功，是否查看订单详情？"
                                            this.orderVisible = true
                                        }else{
                                            this.orderText = "订单已生成，是否查看订单详情？"
                                            this.orderVisible = true
                                        }
                                    })
                                }else{
                                    this.getPayOrder(orderNumber)
                                }
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
            goOrderList(){
                this.orderVisible = false
                this.$router.push('/myOrder?flag=common')
            }

        },
        // mounted 里的数据因为和其他页面重复通过mixin提取出来了
        computed:{
            getState(){
                return this.$store.state.mShowControlMeue
            },
            isLogin(){
                return this.$store.state.isLogin
            },
            // 获取二级菜单的index
            getCurrentIndex(){
                return this.$route.query.currentIndex ? this.$route.query.currentIndex : ""
            },
            // 获取三级菜单
            getThirdIndex(){
                return this.$route.query.thirdIndex ? this.$route.query.thirdIndex : ""
            }
        },
        watch:{
            getNavIndex:{
                handler(newValue,oldValue){
                    this.getThemeListData(1,100,newValue)
                    this.mShowControlMeue = true
                    this.curIndexClassify = 0
                },
                immediate: true  //最初绑定值的时候也执行函数getThemeId
            }
        }
    }
</script>
<style scoped>
    @import "~assets/swiper/swiper.css";
    .generalOrder{
        margin:20px 0;
    }
    .advise{
        background:#e6963e;
    }
    .loginTxt{
        text-align: center;
        font-size: 16px;
    }
    #qrcode {
        padding-left:30px;
        height: 200px;
        width: 200px;
    }
    .codeTip{
        text-align: center;
        background:var(--color-main);
        color:#fff;
        width:200px;
        margin:20px auto 0;
        padding:5px 0;
        line-height: 20px;
    }
    .textTip div{
        padding:0 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
    .textTip span{
        font-weight: bold;
    }
    .textTip .money{
        padding:0 30px;
        margin-top:5px;
        margin-bottom: 10px;
    }
    .swiper-slide{
        width:auto;
        padding:16px 25px;
        min-width: 130px;
        color:#fff;
        cursor: pointer;
        font-size:14px;
        text-align: center;
    }
    .swiper-container.swiper2{
        width:1200px;
        background:rgba(28, 105,177,.7);
        position: absolute;
        bottom:0;left:0;
        z-index: 10;
    }
    .topBanner{
        position: relative;
    }
    .fotBtn{
        margin:40px auto 40px;
    }
    .tabTitle{
        height: 48px;
        background:var(--color-main);
        display: flex;
        font-size:14px;
        color:#fff;
        line-height: 48px;
        cursor: pointer;
        /* position: absolute;
        bottom:0;left:0; */
        z-index: 10;
    }
    .tabTitle.showMobile{
        display: none;
    }
    .tabTitle .tabItem{
        padding:0 20px;
        min-width: 130px;
        text-align: center;
        flex-shrink: 0;
    }
    .tabTitle .tabItem.active,.swiper2 .active{
        background: #5fbf40;
        /* background: rgb(29, 154, 236); */
    }
    /* 左侧 */
    .classifyCont{
        height:100%;
        min-height:400px;
        display: flex;
        margin-top:10px;
        justify-content: space-between;
    }
    .classifyLeft{
        width:180px;
        height:100%;
    }
    .classifyLeft .cl_item{
        height: 50px;
        width:100%;
        text-align: left;
        line-height:50px;
        cursor: pointer;
        font-size:14px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        position: relative;
        border-bottom:1px solid #ececec;
        font-weight: 500;
        padding:0 15px;
    }
    .classifyLeft .topImg{
        width:100%;
        margin-bottom:10px;
            
    }
    .classifyLeft .topImg img{
        height: 100%;
        width:100%;
    }
    .classifyLeft .cl_item img{
        display:inline-block;
        height:15px;
        position: absolute;
        top:17px;left: 15px;
    }
    .classifyLeft .cl_item.clActive{
        background:#f5f5f5;
        color:var(--color-main);
    }
    
    .classifyRight{
        width: calc(100% - 200px);
        border:1px solid #ececec;
    }
    .mobileWidthMain{
        background-color:#fff;
    }
    .m_control{
        display:none;
    }
    /* 链接 */
    .link{
        padding: 0 30px 0;
    }
    .linkItem{
        margin-bottom: 20px;
    }
    .linkItem>span{
        padding:5px 10px;
        line-height: 30px;
        background:#73fb5b;
        cursor: pointer;
    }
    @media screen and (max-width: 768px){
        .m_fotBtn{
            margin:0.5rem auto 0.5rem;
        }
         .loginTxt{
            font-size: .3rem;
        }
        .tabTitle{
            width:100%;
            height: 0.7rem;
            font-size:0.26rem;
            color:#fff;
            line-height: 0.7rem;
            cursor: pointer;
            overflow: auto;
            position: relative;
        }
        .tabTitle.showMobile{
            display: block;
            display: flex;
        }
        .tabTitle .tabItem{
            padding:0 0.3rem;
            min-width:2.4rem;
            text-align: center;
        }
        .swiper-slide{
            width:auto;
            padding:0.3rem 0.5rem;
            min-width:2rem;
            font-size:0.26rem;
        }
        .swiper-container.swiper2{
            width:100%;
        }
        /* 导航加遮罩 */
        .shadow{
            height:0.7rem;
            width:0.5rem;
            position: absolute;
            right:0;bottom:0;
            background: url(~assets/img/menu_right.png) no-repeat center;
            /* background-size:contain ; */
        }

        /* 详情添加控制面板 */
        .classifyCont,.fotBtn{
            display:none;
        }
        .m_control{
            display: block;
        }
        .m_titleMenue{
            padding:0 0.3rem 0.3rem;
            margin-bottom: 0.3rem;
        }
        .menueItem{
            position: relative;
            padding-left:0.7rem;
            padding-right: 0.4rem;
            height:1rem;
            border-bottom: 1px dashed #d7dae2;
            line-height: 1rem;
            font-size:0.28rem;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        .menueItem img{
            height: 0.3rem;
            position: absolute;
            top:0.34rem;left:0.2rem;
        }
         /* 链接 */
        .link{
            padding: 0.2rem 0.3rem 0.2rem;
            width:90%;
            margin:0 auto;
            font-size:0.28rem;
        }
        .linkItem{
            margin-bottom: 0.2rem;
        }
        .linkItem>span{
            padding:0.1rem 0.2rem;
            line-height: 0.5rem;
        }
        .noData{
            text-align: center;
            margin-top: 0.6rem;
        }
        /* 动画 */
        .aa{
            position: relative;
        }
        .animateTip{
            height: .6rem;
            width: .6rem;
            animation: dh linear 3s infinite alternate;
            position: absolute;
            top:0.05rem;
            right: 0.05rem;
            z-index: 10;
        }
        @keyframes dh{
            0%,50%,75%{opacity: 1;}
            25%,100%{opacity:0}
        }

    }
</style>